import { DateTime } from 'luxon';
import { matchPath } from 'react-router';
import { DangerousGoods } from '../types';
import _ from 'lodash';

export const isMatch = (path: string, pathname: string, exact?: boolean, strict?: boolean) => {
    return matchPath(pathname, {
        path,
        exact,
        strict
    }) !== null;
};

export type MatchRules = undefined | true | false | { exact?: boolean, strict?: boolean };
export type NormalizedMatchRules = { match: boolean, exact?: boolean, strict?: boolean };

export const normalizeMatchRules = (matchRules: MatchRules) => {
    if (matchRules === false || matchRules === true || matchRules === undefined) {
        return {
            match: (matchRules ?? true) as boolean,
            exact: undefined,
            strict: undefined
        }
    }

    return {
        match: true,
        ...matchRules
    } as NormalizedMatchRules
};

export type DistributiveOmit<T, K extends keyof any> = T extends any
    ? Omit<T, K>
    : never;

export const numericTierFromBrt = (tier: unknown) => {
    const ntier = Number(tier)
    return isNaN(ntier) ? '' : (ntier - 80) / 2
}

export const BASE_URL = document.getElementsByTagName('base')[0].getAttribute('href') ?? '';

export const unNumbersList = (dangerousGoods: DangerousGoods[]) =>
    _(dangerousGoods)
        .groupBy('unNumber')
        .map((gr, un) => [un, gr.every(dg => dg.limitedQuantity)] as const)
        .orderBy(tp => tp[0])
        .value()

export const adrClassesList = (dangerousGoods: DangerousGoods[]) =>
    _(dangerousGoods)
        .groupBy('adrClass')
        .map((gr, cl) => [cl, gr.every(dg => dg.limitedQuantity)] as const)
        .orderBy(tp => tp[0])
        .value()

export const isoCodeToSize = (isoCode: string) => {
    switch (isoCode[0]) {
        case '1':
        case '2':
        case 'A'://= "23.5";
        case 'B'://= "24";
        case 'C'://= "24.5";
        case 'D'://= "24.5";
        case 'E'://= "25.5";
        case 'F'://= "26.5";
            return 20;
        case '3':
            return 30;
        case '4':
        case 'G'://= "41";
        case 'H'://= "43";
        case 'K'://= "44.5";
        case 'L'://= "45";
        case 'M'://= "48";
        case 'N'://= "49";
        case 'P'://= "53";
            return 40;
        default:
            return null;
    }
}